import { userConstants, commonConstants } from '../_constants';
import { userService } from '../_services';
import { history } from '../_helpers';
import { newsEventEffect } from '../_effects/newsEventEffect';
import { alertActions } from './alertActions';

export const newsEventAction = {
  newsEvent,
};

function newsEvent(newsEvent) {
  return (dispatch) => {
    dispatch(request(newsEvent));
    newsEventEffect.newsEvent().then(
      (newsEvent) => {
        dispatch(success(newsEvent));
      },
      (error) => {
        console.log('action error', error);
        dispatch(failure(error.toString()));
      }
    );
  };

  function request(newsEvent) {
    return { type: commonConstants.NEWSEVENT_REQUEST, newsEvent };
  }
  function success(newsEvent) {
    return { type: commonConstants.NEWSEVENT_SUCCESS, newsEvent };
  }
  function failure(error) {
    return { type: commonConstants.NEWSEVENT_FAILURE, error };
  }
}
